<template>
  <div class="grid">
    <div class="col-12">
      <div class="card">
        <h3>
          {{
            $t("cuentaYFacturacion.datosContacto.contactoCuentaPrincipal.titulo")
          }}
        </h3>
        <p style="height: 25%;">
          {{
            $t("cuentaYFacturacion.datosContacto.contactoCuentaPrincipal.info")
          }}
        </p>
        <form class="card" @submit.prevent="onSubmit">
          <div class="grid col-12 p-field">
            <label for="contacto"
              ><b
                >{{
                  $t("cuentaYFacturacion.datosContacto.seleccionarUsuario")
                }}*</b
              ></label
            >
            <small>{{
              $t("cuentaYFacturacion.datosContacto.rolObligatorio")
            }}</small>
            <div class="p-inputgroup col-12">
              <Dropdown
                class="input"
                v-model="contacto"
                :options="dropdownContactos"
                optionLabel="email"
                optionValue="id"
                showToggleAll="false"
                @change="onDropdownChange"
                :placeholder="$t('cuentaYFacturacion.datosContacto.placeholder.seleccionarContacto')"
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { 
  ALTA_COMUNICA_CLIENTE,
  DELETE_COMUNICA_CLIENTE,
  COMUNICA_CLIENTE_BY_ID_CLIENTE_AND_RAZON_AND_ID_USUARIO
} from "@/graphQLQueries/ComunicaClienteQueries";

export default {
  name: "ContactoCuentaPrincipal",
  props: [
    "users",
    "cliente",
  ],
  data() {
    return {
      contacto: {},
      dropdownContactos: [],
      errores: [],
      idComunicaCliente: null,
    };
  },
  created() {
    this.loadUsers();
  },
  watch: {
    users(){
      this.loadUsers();
    },
  },
  methods: {
    loadUsers(){
      let emails = this.users.map((user) => {
        if(user.email != null){
           return {
              email: user.email,
              id: user.id,
            }
        }
      });
      emails = emails.filter(function( user ) {
        return user !== undefined;
      });
      this.dropdownContactos = emails;
      this.users.forEach(u => {
        if(u.id != null)
          this.getComunicaCliente(u.id);
      });
    },
    getComunicaCliente(idUsuario){
      this.$apollo
        .query({
          query: COMUNICA_CLIENTE_BY_ID_CLIENTE_AND_RAZON_AND_ID_USUARIO,
          variables: {
            idCliente: this.cliente.id,
            idUsuario: idUsuario,
            razon: 'PRINCIPAL'
          }
        })
        .then((data) => {
          let cc = data.data.comunicaClienteByIdClienteAndRazonAndIdUsuario;
          this.contacto = cc.idUsuario
          this.idComunicaCliente = cc.id
        })
        .catch(() => {}); // Agregado el catch para evitar mensajes de error en consola
    },
    onDropdownChange(evt) {
      this.deleteComunicaCliente(this.idComunicaCliente)
      this.altaComunicaCliente(evt.value)
    },
    altaComunicaCliente(idUsuario){
      this.$apollo
        .mutate({
          mutation: ALTA_COMUNICA_CLIENTE,
          variables: {
            altaComunicaClienteRequest: {
              idCliente: this.cliente.id,
              idUsuario: idUsuario,
              razon: 'PRINCIPAL'
            }
          }
        }).then((data) => {
          let cc = data.data.altaComunicaCliente;
          this.contacto = cc.idUsuario
          this.idComunicaCliente = cc.id
        })
        .catch(() => {});
    },
    deleteComunicaCliente(idCC){
      this.$apollo
        .mutate({
          mutation: DELETE_COMUNICA_CLIENTE,
          variables: {
            idComunicaCliente: idCC,
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
</style>